import React from "react";
import "./Award.css";
import awardImage from "../../images/Awards/businessrate-best-of-2026.png";

const Award = () => {
  return (
    <section className="award-section">
      <img
        src={awardImage}
        alt="BusinessRate Best of 2026 Award Winner - Consumer Protection Networks, Consultant, Conroe, Texas"
        className="award-image"
        loading="lazy"
      />
      <div className="award-text">
        <span className="award-eyebrow">Award Winner</span>
        <h3 className="award-title">Best of 2026 by BusinessRate</h3>
        <p className="award-desc">
          Consumer Protection Networks was named a Best of 2026 Consultant in
          Conroe, Texas by BusinessRate, based on real client ratings from
          Google Reviews.
        </p>
      </div>
    </section>
  );
};

export default Award;
